
import {createSlice} from "@reduxjs/toolkit"

const initialStateValue = []

export const AdminUsersSlice = createSlice({
    name: "AdminUsers",
    initialState:{ value:initialStateValue},
    reducers: {
        setAdminUsers:(state, action)=> {
            state.value = action.payload
        },
        clearAdminUsers:(state)=>{
            state.value = initialStateValue
        }
    }
})

export default AdminUsersSlice.reducer;

export const {setAdminUsers, clearAdminUsers} =  AdminUsersSlice.actions